import { useEffect, useRef, useState } from "react";
import { useScroll } from "../../hooks/use-scroll";
import { useRect } from "../../hooks/use-rect";
import { useWindowSize } from "react-use";
import { mapRange, clamp } from "../../utils/Maths";
import { gsap } from "gsap";
import { useTranslation } from "react-i18next";

import s from "./Biography.module.scss";
import img from "../../assets/images/starck.jpg";
import ParagraphReveal from "../ParagraphReveal/ParagraphReveal";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

const Biography = () => {
  const letterWrapperRef = useRef();
  const imgRef = useRef();
  const opacityTimelineRef = useRef(gsap.timeline({ paused: true }));
  const rotateTimelineRef = useRef(gsap.timeline({ paused: true }));
  const { height: windowHeight } = useWindowSize();
  const { t } = useTranslation();

  const [wrapperRectRef, wrapperRect] = useRect();

  useEffect(() => {
    const text = t("biography.headline");
    const spansArray = [];
    const letters = text.split("");

    gsap.set(letterWrapperRef.current, {
      rotate: 5,
    });

    letters.forEach((letter) => {
      const span = document.createElement("span");
      span.innerHTML = letter;

      span.style.opacity = 0.14;

      if (letter.toLowerCase() === "t") {
        span.classList.add("red");
      }

      letterWrapperRef.current.appendChild(span);
      spansArray.push(span);
    });

    rotateTimelineRef.current.to(letterWrapperRef.current, {
      rotate: 0,
    });

    opacityTimelineRef.current.to(spansArray, {
      opacity: 1,
      stagger: 0.033,
    });

    gsap.fromTo(
      imgRef.current,
      {
        opacity: 0,
        y: 100,
        scale: 1.5,
      },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        scrollTrigger: {
          trigger: imgRef.current,
          start: "top 50%",
          end: "+=75%",
          scrub: true,
          // markers: {},
        },
      }
    );

    return () => {
      rotateTimelineRef.current.kill();
      opacityTimelineRef.current.kill();
    };
  }, []);

  useScroll(({ scroll }) => {
    const start = wrapperRect.top - windowHeight * 0.8;
    const end = start + wrapperRect.height;

    let progress = mapRange(start, end, scroll, 0, 1);
    progress = clamp(0, progress, 1);

    rotateTimelineRef.current.progress(progress);
    opacityTimelineRef.current.progress(progress);
  });

  return (
    <div className={s.biography}>
      <p
        ref={(node) => {
          letterWrapperRef.current = node;
          wrapperRectRef(node);
        }}
        className={s.intro}
      ></p>

      <ParagraphReveal className={s.alt}>
        {t("biography.description")}
        <br /> <br /> <br />
        {t("biography.description_bis")}
      </ParagraphReveal>

      <div className={s.imgWrapper}>
        <img ref={imgRef} src={img} alt="" />
      </div>
    </div>
  );
};

export default Biography;
